import { Note } from 'types/Load';
import { Maybe } from 'types/UtilityTypes';

const THREE_G_TMS_INTERNAL_ID_NOTE_SOURCE = '3G_TMS_InternalID';

export const getThreeGInternalIdFromLoadNotes = (
  notes: Note[] | undefined
): Maybe<string> => {
  if (!notes?.length) {
    return null;
  }

  const internalIdNote = notes.find(
    (note) => note.source === THREE_G_TMS_INTERNAL_ID_NOTE_SOURCE
  );
  const internalId = internalIdNote?.note?.trim();

  if (!internalId || !/^\d+$/.test(internalId)) {
    return null;
  }

  return internalId;
};
